<micro-picklist title="Contacts"
                [all]="all"
                [listMinSize]="listMinSize"
                [(selectedIds)]="selectedItems"
                (selectedIdsChange)="onNgModelChange($event)"
                availableLabel="Unassigned Contacts"
                selectedLabel="Assigned Contacts"
                filterLabel="Contact">
</micro-picklist>
